import CoreLayout from './CoreLayout'
import enhance from './CoreLayout.enhancer'

export default enhance(CoreLayout)
